import { render } from "./OurTeam.vue?vue&type=template&id=0d8ae6b5&scoped=true"
import script from "./OurTeam.vue?vue&type=script&lang=js"
export * from "./OurTeam.vue?vue&type=script&lang=js"

import "./OurTeam.vue?vue&type=style&index=0&id=0d8ae6b5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8ae6b5"]])

export default __exports__